import { sumFloats } from '../common/UtilsFunctions'

function getCaidaTotal (analisys) {
  let {incomestible, terron, caidaZaranda, manchado, partido, helado, chuzo, roido, picadoCampo, contrastante, descorticado, quebrado, brotado, revolcado, leveA} = analisys
  let totalCaida = [incomestible, terron, caidaZaranda, manchado, partido, helado, chuzo, roido, picadoCampo, contrastante, descorticado, quebrado, brotado, revolcado, leveA]
  return totalCaida.reduce((a, b) => sumFloats(a, b)).toFixed(2)
}

function getDefectosTotal (analisys) {
  let {leveB, cascado, manchadoMaquina, pinto, bolita, oxidado, puntaChaucha, arrugado, venoso, decolorido} = analisys
  let totalDefectos = [leveB, cascado, manchadoMaquina, pinto, bolita, oxidado, puntaChaucha, arrugado, venoso, decolorido]
  return totalDefectos.reduce((a, b) => sumFloats(a, b)).toFixed(2)
}

export {
  getCaidaTotal,
  getDefectosTotal
}
